import React from "react"

const MicIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 8C7 6.67392 7.52678 5.40215 8.46447 4.46447C9.40215 3.52678 10.6739 3 12 3C13.3261 3 14.5979 3.52678 15.5355 4.46447C16.2036 5.13256 16.6631 5.97025 16.8721 6.87635L13.1519 10.2654C13.1028 10.2553 13.052 10.25 13 10.25H10C9.58579 10.25 9.25 10.5858 9.25 11C9.25 11.4142 9.58579 11.75 10 11.75H11.5222L8.46447 14.5355C7.52678 13.5979 7 12.3261 7 11V8ZM11 7.25C10.5858 7.25 10.25 7.58579 10.25 8C10.25 8.41421 10.5858 8.75 11 8.75H13C13.4142 8.75 13.75 8.41421 13.75 8C13.75 7.58579 13.4142 7.25 13 7.25H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.25C4.41421 9.25 4.75 9.58579 4.75 10V11C4.75 12.9228 5.51384 14.7669 6.87348 16.1265C6.9203 16.1733 6.96769 16.2195 7.01564 16.2649C7.31643 16.5496 7.3294 17.0243 7.04462 17.3251C6.75984 17.6259 6.28515 17.6389 5.98436 17.3541C5.9265 17.2993 5.86931 17.2437 5.81282 17.1872C4.17187 15.5462 3.25 13.3206 3.25 11V10C3.25 9.58579 3.58579 9.25 4 9.25ZM20 9.25C20.4142 9.25 20.75 9.58579 20.75 10V11C20.75 13.3206 19.8281 15.5462 18.1872 17.1872C16.724 18.6504 14.7958 19.5419 12.75 19.7178V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V19.7178C10.3757 19.6426 9.52291 19.4368 8.71875 19.1115C8.33476 18.9561 8.1494 18.5189 8.30473 18.1349C8.46006 17.751 8.89727 17.5656 9.28125 17.7209C10.137 18.0671 11.059 18.25 12 18.25C13.9228 18.25 15.7669 17.4862 17.1265 16.1265C18.4862 14.7669 19.25 12.9228 19.25 11V10C19.25 9.58579 19.5858 9.25 20 9.25Z"
        fill="currentColor"
      />
      <path
        d="M16.0474 15.0474C17.2976 13.7971 18 12.1014 18 10.3333C18 9.83767 17.4027 9.58727 17.0492 9.93477L10.9572 15.9242C10.5492 16.3253 10.7612 17 11.3333 17C13.1014 17 14.7971 16.2976 16.0474 15.0474Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5303 1.46967C22.8232 1.76256 22.8232 2.23744 22.5303 2.53033L2.53033 22.5303C2.23744 22.8232 1.76256 22.8232 1.46967 22.5303C1.17678 22.2374 1.17678 21.7626 1.46967 21.4697L21.4697 1.46967C21.7626 1.17678 22.2374 1.17678 22.5303 1.46967Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default MicIcon
